import React, { useState } from 'react';

import { useModal } from 'shared/hooks';
import { Option } from 'shared/types';
import { Container } from 'shared/ui';

import { AddEditOptionModal, RemoveOptionModal, SubjectsOptions } from './ui';

export const OptionsPage = () => {
  const { isOpen: isAddEditModalOpen, open: openAddEditModal, close: closeAddEditModal } = useModal();
  const { isOpen: isRemoveModalOpen, open: openRemoveModal, close: closeRemoveModal } = useModal();
  const [currentOption, setCurrentOption] = useState<Option | null>(null);
  const resetCurrentOption = () => setCurrentOption(null);

  return (
    <Container>
      <div className="grid h-screen w-full grid-cols-2 gap-5 rounded-3xl bg-white px-[25px] pb-5 pt-10 shadow-section">
        <SubjectsOptions onAddEdit={openAddEditModal} onRemove={openRemoveModal} onSetOption={setCurrentOption} />

        <div>
          <div className="flex items-center justify-between">
            <h2>Grades</h2>

            <button>Add new grade</button>
          </div>
        </div>
      </div>

      <AddEditOptionModal
        isOpen={isAddEditModalOpen}
        close={closeAddEditModal}
        option={currentOption}
        onReset={resetCurrentOption}
      />
      <RemoveOptionModal
        isOpen={isRemoveModalOpen}
        close={closeRemoveModal}
        id={currentOption?.id}
        onReset={resetCurrentOption}
      />
    </Container>
  );
};
